export const ACCOUNTED_CARDHOLDERS_RECEIVED = "ACCOUNTED_CARDHOLDERS_RECEIVED";
export const UNACCOUNTED_CARDHOLDERS_RECEIVED = "UNACCOUNTED_CARDHOLDERS_RECEIVED";
export const PROCEDURE_INFO_RECEIVED = "PROCEDURE_INFO_RECEIVED";
export const RESET_EVACUATION = "RESET_EVACUATION";
